(function () {
    Element.prototype.appendAfter = function (element) {
        element.parentNode.insertBefore(this, element.nextSibling);
    };

    // If the form field has an input-label-wrapper, we want to ignore it, since it the label should be positioned at the left of the form control.
    const hasInputLabelWrapper = (formField) =>
        Boolean(formField.querySelector('.input-label-wrapper'));

    function handeActiveState(value, formField) {
        if (value.length === 0) {
            formField.classList.remove('active');
        } else {
            formField.classList.add('active');
        }
    }

    function getFormControl(formField) {
        /** The list is needed (instead of just 'input') to make sure the code is not applied to checkboxes, radio buttons and hidden fields **/
        return formField.querySelector(
            'select, textarea, [type="email"], [type="number"], [type="password"], [type="search"], [type="tel"], [type=text]',
        );
    }

    function handleActiveStateOfInputsAndTextAreas(formFields) {
        [].forEach.call(formFields, (formField) => {
            const formControl = getFormControl(formField);
            if (!formControl) return;
            if (hasInputLabelWrapper(formField)) return;

            handeActiveState(formControl.value, formField);

            if (formControl.tagName === 'SELECT') {
                formControl.addEventListener('change', () =>
                    handeActiveState(formControl.value, formField),
                );
            } else {
                formControl.addEventListener('keyup', () =>
                    handeActiveState(formControl.value, formField),
                );
            }
        });
    }

    function moveLabelsAfterInputsAndTextAreas(formFields) {
        [].forEach.call(formFields, (formField) => {
            const label = formField.querySelector('label');
            if (!label) return;
            if (hasInputLabelWrapper(formField)) return;

            const formControl = getFormControl(formField);
            if (!formControl) return;

            label.appendAfter(formControl);
        });
    }

    const formFields = document.querySelectorAll('.form-field');
    moveLabelsAfterInputsAndTextAreas(formFields);
    handleActiveStateOfInputsAndTextAreas(formFields);

    /**
     * When the form has errors, Kentico re-renders the complete form (no page reload), so to move the labels back
     * to the correct position again, we listen to changes to the kentico-form-widget-form divs.
     */
    const kenticoFormWidgets = document.querySelectorAll('.kentico-form-widget-form');
    [].forEach.call(kenticoFormWidgets, (formWidget) => {
        const parentOfFormWidget = formWidget.parentElement;
        const kenticoFormWidgetObserver = new MutationObserver(() => {
            const formFields = parentOfFormWidget.querySelectorAll('.form-field');
            moveLabelsAfterInputsAndTextAreas(formFields);
            handleActiveStateOfInputsAndTextAreas(formFields);
        });

        kenticoFormWidgetObserver.observe(parentOfFormWidget, {
            childList: true, // we only listen to the removal/adding of direct child nodes. So this is triggered on the re-render of the .kentico-form-widget-form div
        });
    });
})();
